import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { IBallotSearchRequest } from '../models/search/ballot-search-filter';
import { Observable } from 'rxjs';
import { IApiResponse } from '../../../../shared/models/api-response';
import { IBallotSearchResult } from '../models/search/ballot-search-result';
import { IPaginatedCollection } from '../../../../shared/models/paginated-collection';
import { IBallotTypeEnumValue, IConnectEnumValue, IUnifiedBallotStatusEnumValue } from '../../../../shared/models/connect-enum';
import { UnifiedBallotStatus } from '../../../../shared/enums/unified-ballot-status-enum';

@Injectable({
  providedIn: 'root'
})
export class BallotSearchService {
  baseUrl: string = `${environment.servicesUrl.ballot}api/ballots`;

  constructor(private httpClient: HttpClient) { }

  public searchBallots(searchFilter: IBallotSearchRequest) : Observable<IApiResponse<IPaginatedCollection<IBallotSearchResult>>> {
    return this.httpClient.post<IApiResponse<IPaginatedCollection<IBallotSearchResult>>>(`${this.baseUrl}/search`, searchFilter);
  }

  public searchBallotsAllPages(searchFilter: IBallotSearchRequest) : Observable<IApiResponse<IPaginatedCollection<IBallotSearchResult>>> {
    return this.httpClient.post<IApiResponse<IPaginatedCollection<IBallotSearchResult>>>(`${this.baseUrl}/searchBallotsAllPages`, searchFilter);
  }

  public getBallotTypeEnums() : Observable<IApiResponse<IBallotTypeEnumValue[]>> {
    return this.httpClient.get<IApiResponse<IBallotTypeEnumValue[]>>(`${this.baseUrl}/get-ballot-types`);
  }

  public getViewableBallotStatusEnums() : Observable<IApiResponse<IConnectEnumValue<UnifiedBallotStatus>[]>> {
    return this.httpClient.get<IApiResponse<IConnectEnumValue<UnifiedBallotStatus>[]>>(`${this.baseUrl}/get-viewable-ballot-status`);
  }

  public getUnifiedBallotStatusEnumDto() : Observable<IApiResponse<IUnifiedBallotStatusEnumValue[]>> {
    return this.httpClient.get<IApiResponse<IUnifiedBallotStatusEnumValue[]>>(`${this.baseUrl}/get-unified-ballot-status-enum-dto`);
  }

}
